export default "__VITE_ASSET__Kre574J9__"